<script>

import TweenMax, {Expo, Power3} from 'gsap/TweenMax';
import UiButton from '@/components/ui/Button';
import { mapGetters } from 'vuex';
import config from '@/config';

export default {
  name: 'Intro',
  components: {
    UiButton
  },
  data() {
    return{
      isLeaving: false,
      showDivIndex: 1,
    }
  },
  mounted() {
    this.$nextTick( () => {
      this.startApp();
    });
  },
  computed: {
    ...mapGetters({
      locale: 'I18n/locale',
      viewport: 'App/viewport'
    }),
    mainLogo() {
      return this.locale === 'fr' ? '/assets/logos/titre-fr.svg' : '/assets/logos/titre-en.png'
    }
  },
  methods: {
    startApp() {
      
      //preload future stuff
      if(!this.$store.getters['Preload/hasPreload']('Intro')) {
        this.$store.dispatch('Preload/START', "Intro");
      }
      
      TweenMax.from(this.$el, 1.5, {alpha:0, ease:Expo.easeOut, delay:1, onComplete: () => {
        TweenMax.delayedCall(3, this.switchVisible.bind(this));
      }});
    },

    switchVisible(){
      TweenMax.to(this.$refs[`Panel${this.showDivIndex}`], .8, {alpha:0, ease:Expo.easeInOut, onComplete: () => {
        this.showDivIndex++;
        TweenMax.from(this.$refs[`Panel${this.showDivIndex}`], .8, {alpha:0, ease:Expo.easeInOut});
      
        if(this.showDivIndex < 3) {
          TweenMax.delayedCall(3, this.switchVisible.bind(this));
        }
        else{
          TweenMax.from(this.$refs.Exit.$el, .6, {alpha:0, y:20, ease:Expo.easeOut, delay:.8});
          TweenMax.from(this.$refs.Titre, 1.2, {y:10, alpha:0, ease:Power3.easeInOut});
        }
      }});
    },

    exit(){
      config.ga('begin', this.locale);
      
      TweenMax.to(this.$el, 2, {alpha:0, ease:Expo.easeOut, onComplete: () => {
        this.$router.push({name:`BeforeEnter${this.locale.toUpperCase()}`});
      }});
    },
  }
};
</script>

<template>
  <div class="Intro">
    <div ref="Panel1" :class="['panel', {visible:showDivIndex == 1}]">
      <p class='text' v-html="$t('intro.creation')" />
      <img class="-svg logo-jeune-pousse" src="/assets/logos/intro_logo_pousses.svg" alt="logoPousses"/>
      <p class='text' v-html="$t('intro.year')" />
    </div>
    <div ref="Panel2" :class="['panel', {visible:showDivIndex == 2}]">
      <p class='text' v-html="$t('intro.production')" />
      <img class='-svg logo-onf' src="/assets/logos/intro_logo_onf.svg" alt="logoONF"/> 
      <p class='text' v-html="$t('intro.collaboration')" />
      <img class='-svg logo-uqam' src="/assets/logos/intro_logo_uqam.svg" alt="logoUQAM"/>
    </div>
    <div ref="Panel3" class="panel intro" :class="{visible:showDivIndex == 3}"> 
      <img ref="Titre" class='-svg logo-titre' :src="mainLogo" alt="imgTitre" />
      <ui-button ref="Exit" class="next-buttton" v-on:pressed="exit" />
    </div>
  </div>
</template>


<style scoped lang="scss">
.Intro {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  @include flexbox(center-vertical);

  @include ipad(landscape) {
    display: none;
  }
}

.-svg {
  width: 100%;
  height: auto;
}

.panel {
  width: 50%;
  text-align: center;
  @include flexbox(center-vertical);
  display: none;

  .text {
    margin: 0px;
    padding: 0px;
    color: $c-shamrock;
  }

  &.visible {
    display: block;
    opacity: 1;
  }
}

.logo-jeune-pousse{ 
  margin: 50% 0px;
  width: 125px;

  @include ipad {
    width: 200px;
  }
}

.logo-onf, .logo-uqam {
  margin: 25% 0px;
  width: 125px;

  @include ipad {
    width: 200px;
  }
}

.logo-uqam {
  margin-bottom: 0px;
}

.intro {
  position: relative;
  width: 100%;
  height: 100%;
  background-image:url("/assets/logos/titre-bg.gif"), linear-gradient(180deg, #143732 50%, #0b1d20 50%);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% auto;

  @include ipad {
    background-position: center 40%;
  }

  .logo-titre {
    width: 60%;
    height: auto;
    position: fixed;
    bottom: 23%;
    left: 20%;

    @include ipad {
      bottom: 21%;
      width: 50%;
      left: 25%;
    }
  }

  .next-buttton {
    width: 45px;
    position: fixed;
    bottom: 4.5%;
    left: 50%;
    margin-left: -22.5px;

    @include ipad {
      width: 70px;
      bottom: 8%;
      margin-left: -35px;
    }
  }
}
</style>
